import { dark } from '@clerk/themes'

/**
 * Clerk UI tuned to dizcant’s dark glass surface and purple accent.
 * Forgot-password lives inside the SignIn path flow (`/sign-in/...`).
 */
export const clerkAppearance = {
  baseTheme: dark,
  variables: {
    colorPrimary: '#5d5cff',
    colorBackground: '#1e1e22',
    colorInputBackground: '#1b1b1d',
    colorInputText: '#e5e1e4',
    colorText: '#f4f4f5',
    colorTextSecondary: '#a1a1aa',
    colorDanger: '#ffb4ab',
    colorNeutral: '#908fa1',
    borderRadius: '0.5rem',
    fontFamily:
      '"Inter Variable", Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
    fontFamilyButtons:
      '"Sora Variable", Sora, ui-sans-serif, system-ui, -apple-system, sans-serif',
  },
  elements: {
    rootBox: 'mx-auto w-full',
    card: 'border border-white/10 bg-[#1e1e22]/95 shadow-[0_0_24px_rgb(93_92_255_/_0.2)]',
    headerTitle: 'text-[#f4f4f5]',
    headerSubtitle: 'text-[#a1a1aa]',
    socialButtonsBlockButton:
      'border border-white/10 bg-[#1b1b1d] text-[#f4f4f5] hover:bg-[#2a2a2c]',
    formFieldLabel: 'text-[#a1a1aa]',
    formFieldInput:
      'border border-white/10 bg-[#1b1b1d] text-[#e5e1e4] focus:border-[#5d5cff]/50',
    formButtonPrimary:
      'bg-gradient-to-br from-[#5d5cff] to-[#14d1ff] text-white shadow-none hover:opacity-90',
    footerActionLink: 'text-[#c1c1ff] hover:text-[#c1c1ff]/80',
    identityPreviewEditButton: 'text-[#c1c1ff]',
    formFieldAction: 'text-[#c1c1ff]',
    alternativeMethodsBlockButton: 'text-[#c1c1ff]',
  },
}
